import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import ShiftLocationPicker from 'modules/shift_management/components/ShiftManagement/ShiftLocationPicker'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'

interface Props {
  locationFilterValue: Field
  workAreaFilterValue: Field
}
const LocationForm = observer(({ locationFilterValue, workAreaFilterValue }: Props) => {
  const { isEnabled: hasSelection } = useSelectionState()

  return (
    <Box gap="s8">
      {!hasSelection && (
        <ShiftLocationPicker
          locationField={locationFilterValue}
          workAreaField={workAreaFilterValue}
          disabledLocation
        />
      )}
    </Box>
  )
})
export { LocationForm }
